
export const DATE_FORMAT_OPTIONS = Object.freeze({
  year: 'numeric',
  month: 'long',
  day: 'numeric',
});